import { render, staticRenderFns } from "./Tradutores.vue?vue&type=template&id=c0732ff0"
import script from "./Tradutores.vue?vue&type=script&lang=js"
export * from "./Tradutores.vue?vue&type=script&lang=js"
import style0 from "./Tradutores.vue?vue&type=style&index=0&id=c0732ff0&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports